import { FeatureTogglePort } from '../../../shared/ports'

export const IS_ONETRUST_LAZY_LOADING_ENABLED_TOGGLE_KEY =
  'cb_enable_onetrust_lazy_loading'

export function isOneTrustLazyLoadingEnabled(
  featureTogglePort: FeatureTogglePort
) {
  return featureTogglePort(IS_ONETRUST_LAZY_LOADING_ENABLED_TOGGLE_KEY, false)
}
